import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import {enableProdMode} from '@angular/core';
import {environment} from './environments/environment';

if (environment.production) {
    enableProdMode();
}

async function prepareApp() {
    if ((environment as any).mock) {
        sessionStorage.setItem('authMode', 'oauth');
        const { worker } = await import('./mocks/browser');
        return worker.start({
            serviceWorker: {
                url: '/mockServiceWorker.js'
            },
            onUnhandledFrame: 'bypass',
        });
    }
    return Promise.resolve();
}

prepareApp().then(() => {
    bootstrapApplication(AppComponent, appConfig)
        .catch((err) => console.error(err));
});
